import React, { memo } from 'react'
import Link from 'next/link'
import cn from 'classnames'

import { handleCall } from './handlers'
import s from './btnCall.module.scss'

import { ButtonCallProps } from './types'

const ButtonCall = memo<ButtonCallProps>(({ special }) => {
  return (
    <Link href="tel:+1-888-488-7203" passHref className={s.call}>
      <button
        onClick={() => handleCall()}
        className={cn({ [s.btnCall]: true, [s.special]: special })}
      >
        <img
          src="/home/phone-black.svg"
          className={s.imgCall}
          width={25}
          height={25}
          alt="phone icon"
        />
        <div className={s.containerText}>
          <span className={s.title}>Call: 1 (888) 488-7203</span>
          <span className={s.subtitle}>Mon-Sat 9a-9p ET</span>
        </div>
      </button>
    </Link>
  )
})

export default ButtonCall
